module.exports = __webpack_public_path__ + "img/6.019d2356.png";